import React, { useEffect } from "react";
import { useMap } from "react-leaflet";

const MapController = ({ onMapCreated }) => {
  const map = useMap();

  useEffect(() => {
    if (map) {
      onMapCreated(map);
    }
  }, [map, onMapCreated]);

  return null;
};

export default MapController;
